module.exports = __webpack_public_path__ + "static/pro-development-section-4@2x-11f4716e366732cd7c879cd26f1a1abe.png";